import React from "react";

import { MIGRATIONS_PATH } from "../../../router/path/migrations";
import { useFormTo } from "../../../hooks/useFormTo";

import { Container, StyledLink } from "./styles";

const HeaderDemoResult = ({ migration }) => {
  const { prefix } = useFormTo();
  return (
    <Container>
      <StyledLink
        href={`${prefix}/${MIGRATIONS_PATH.MY_MIGRATION_DETAILS}/${migration?.id}/demo`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Demo Result
      </StyledLink>
    </Container>
  );
};

export default HeaderDemoResult;
